import moment from "moment";

/* ⚠️ Esta função reconstrói cada linha CAMPO A CAMPO. Um campo que não esteja
 * listado no `case` respetivo é silenciosamente deitado fora, por muito que
 * exista no objeto de origem — e o ecrã comporta-se como se o dado nunca
 * tivesse existido, sem erro nenhum.
 *
 * Foi o que aconteceu com o `estabelecimento`: estava na origem, estava na
 * célula que o desenha, e mesmo assim a pastilha da unidade nunca aparecia nas
 * entradas e as ações de outra unidade não eram travadas.
 *
 * Ao acrescentar um campo à linha, acrescentá-lo TAMBÉM aqui. */
const dataGridData = (data) => {
  const rows = data.map((dt) => {
    switch (dt.tipo) {
      case "receita":
        return {
          tipo: "receita",
          orcamento: dt.orcamento,
          id: dt.id,
          contaId: dt.contaId,
          nome: "Parcela",
          descricao: dt.descricao || "",
          data: moment(dt.dataLimitePagamento).format("DD-MM-YYYY"),
          valor:
            dt.quantiaPorPagar > 0
              ? `${dt.quantiaPorPagar.toLocaleString("pt-BR")}$00`
              : `${dt.quantiaPaga.toLocaleString("pt-BR")}$00`,
          receber: "receber",
          estado: dt.estado,
          metodoPagamento: dt.metodoPagamento,
          nrParcela: dt.nrParcela,
          dataLimitePagamento: dt.dataLimitePagamento,
          dataPagamento: dt.dataPagamento,
          parcelaPaga: dt.parcelaPaga,
          documentoEletronico: dt.documentoEletronico,
          cancelamentosDocumentosEletronicos:
            dt.cancelamentosDocumentosEletronicos,
          faturaEReciboEletronicos: dt.faturaEReciboEletronicos,
          cancelamentosRecibosEletronicos: dt.cancelamentosRecibosEletronicos,
          nrRecibo: dt.nrRecibo,
          motivoEncerramento: dt.motivoEncerramento,
          status: dt.status,
          recebidoPor: dt.recebidoPor,
          dataRecebimento: dt.dataRecebimento,
          emitidoPor: dt.emitidoPor,
          dataEmissao: dt.dataEmissao,
          fteEmitidoPor: dt.fteEmitidoPor,
          dataEmissaoFte: dt.dataEmissaoFte,
          rceEmitidoPor: dt.rceEmitidoPor,
          dataEmissaoRce: dt.dataEmissaoRce,
          // Unidade onde a parcela foi paga — a pastilha e o bloqueio das
          // ações leem daqui. A caixa acompanha por ser o recurso quando o
          // recebimento é anterior ao carimbo.
          estabelecimento: dt.estabelecimento,
          caixa: dt.caixa,
        };
      case "entrada":
        return {
          id: dt.id,
          dataPagamento: dt.dataPagamento,
          dataLimitePagamento: dt.dataLimitePagamento,
          valor: dt.valor ? `${dt.valor.toLocaleString("pt-BR")}$00` : "",
          tipo: dt.tipo,
          cliente: dt.cliente,
          tipoEntrada: dt.tipoEntrada,
          metodoPagamento: dt.metodoPagamento,
          descricao: dt.descricao,
          comprovativo: dt.comprovativo,
          nrRecibo: dt.nrRecibo,
          documentoEletronico: dt.documentoEletronico,
          cancelamentosDocumentosEletronicos:
            dt.cancelamentosDocumentosEletronicos,
          entradaRecebida: dt.entradaRecebida,
          recebidoPor: dt.recebidoPor,
          dataRecebimento: dt.dataRecebimento,
          emitidoPor: dt.emitidoPor,
          dataEmissao: dt.dataEmissao,
          // Unidade onde a entrada foi registada — sem isto, a pastilha não
          // desenhava e as ações de outra unidade não eram travadas.
          estabelecimento: dt.estabelecimento,
          caixa: dt.caixa,
        };
      case "saida":
        return {
          id: dt.id,
          dataCriacao: dt.dataCriacao,
          dataLimitePagamento: dt.dataLimitePagamento,
          dataPagamento: dt.dataPagamento,
          valor: `${dt.valor.toLocaleString("pt-BR")}$00`,
          tipo: dt.tipo,
          estado: dt.estado,
          metodoPagamento: dt.metodoPagamento,
          despesaPaga: dt.despesaPaga,
          descricao: dt.descricao,
          comprovativo: dt.comprovativo,
          caixa: dt.caixa,
          categoria: dt.categoria,
        };
      default:
        return {};
    }
  });

  return rows;
};

export default dataGridData;
